import AbstractMediator from "slotworks/mediators/abstract-mediator";
import Bet from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Contract from "slotworks/utils/contract";
import Components from "../components/components";

export default class BigWinMediator extends AbstractMediator {

    public start(): Contract<boolean> {

        let winnings;
        if (GameState.getCurrentGame().getCurrentRecord().beenPaid) {
            winnings = GameState.getCurrentGame().totalCreditsWon;
        } else {
            winnings = GameState.getCurrentGame().getCurrentRecord().creditsWon;
        }
        const stake = Bet.getTotalBet();

        return Components.bigWin.showWin(winnings, stake);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/mediators/big-win-mediator.ts